var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterXBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34489 3.50024L11.3589 14.955L3.18994 24.5002H6.27751L12.7397 16.9283L18.0376 24.5002H24.9328L16.536 12.4804L24.2013 3.50024H21.1616L15.1619 10.5116L10.2651 3.50024H3.34489Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterXBlackIcon);
export default __webpack_public_path__ + "static/media/TwitterX_black_icon.a683df4afcead73d59a9ac3e07cf44ce.svg";
export { ForwardRef as ReactComponent };